import { defineStore } from "pinia";

export const usePetStore = defineStore("pet", {
  state: () => ({
    petAds: [], // Tüm ilanları tutan array
    selectedPet: null, // Seçili ilanın detayları
  }),
  actions: {
    setPetAds(ads) {
      this.petAds = ads;
    },
    // fetchPetDetails fonksiyonunu store'daki veriyi kullanacak şekilde değiştir
    fetchPetDetails(petId) {
      this.selectedPet = this.petAds.find((pet) => pet.id === petId) || null;
      if (!this.selectedPet) {
        //console.log('İlan bulunamadı:', petId);
      }
    },
  },
});
